module.exports = __webpack_public_path__ + "static/media/real.69c23f19.jpg";